import OneIdRedirectPage from "@/pages/auth/one-id"
import type { CustomRoute } from "@/shared/types"
import { Login } from "./login"
import RoleSelectPage from "./one-id/role-select"
import InspectorSelectPage from "./one-id/inspector-select"
import SubmitRequestPage from "./one-id/submit-request"

export const authRoutes: CustomRoute[] = [
  {
    path: "login",
    element: <Login />
  },
  {
    path: "one-id",
    element: <OneIdRedirectPage />
  },
  {
    path: "role-select",
    element: <RoleSelectPage />
  },
  {
    path: "submit-request",
    element: <SubmitRequestPage />
  }
]
